import { validateRegistrationForm } from './forms/register-step-1';

validateRegistrationForm('#register-step-1-modal');
validateRegistrationForm('#register-step-1');

// Exported and used in src/interfaces/1/1/1/templates/v2/register/interfacesteps_viaccount.tpl as static function call as `facelift.[filename].[functionName]`
export { validateRegistrationForm } from './forms/register-step-1';
